import clsx from "clsx";
import SearchBar from "components/FindYourCruise/Components/SearchBar";
import { SectionContainer } from "@silversea-ssc/ui-components-react";
import React, { startTransition, useEffect, useRef, useState } from "react";
import * as styles from "./StickySearchContainer.module.scss";
import { useLingui } from "@lingui/react/macro";

const StickySearchContainer: React.FC<
  React.PropsWithChildren<{ className: string }>
> = ({ className }) => {
  const [isSticky, setIsSticky] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const { i18n, t } = useLingui();

  useEffect(() => {
    const handleScroll = () => {
      if (menuRef.current) {
        const requiredIsSticky =
          menuRef.current.getBoundingClientRect().top <= 0;
        setIsSticky(requiredIsSticky);
      }
    };

    startTransition(() => {
      handleScroll();
    });
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [menuRef]);

  return (
    <React.Fragment>
      <div
        ref={menuRef}
        className={clsx({
          [styles.searchBarWrapperSitcky]: true,
          [styles.searchBarWrapperSitckyActive]: isSticky
        })}
      >
        <SectionContainer
          className={styles.searchBarContainer}
          dataContentName="search_bar"
        >
          <form
            className={className}
            name="search"
            onSubmit={(e) => {
              e.preventDefault();
              return false;
            }}
          >
            <SearchBar placeholder={i18n._(t`Search input placeholder`)} />
          </form>
        </SectionContainer>
      </div>
    </React.Fragment>
  );
};

export default StickySearchContainer;
